import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { ZestLogo } from "../components/ZestLogo";
import { ArrowRight, Menu, X } from "lucide-react";

export function PublicNav() {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav className="fixed top-0 inset-x-0 z-50 bg-white/80 backdrop-blur-lg border-b border-slate-100">
      <div className="max-w-6xl mx-auto px-5 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center">
          <ZestLogo height="h-9" />
        </Link>
        <div className="hidden md:flex items-center gap-8">
          <Link to="/#features" className="text-[13px] text-slate-500 hover:text-slate-900 font-medium transition-colors">Features</Link>
          <Link to="/#pricing" className="text-[13px] text-slate-500 hover:text-slate-900 font-medium transition-colors">Pricing</Link>
          <Link to="/faqs" className="text-[13px] text-slate-500 hover:text-slate-900 font-medium transition-colors">FAQs</Link>
        </div>
        <div className="hidden md:flex items-center gap-3">
          <Button variant="ghost" size="sm" className="text-[13px] h-9" onClick={() => navigate("/login")} data-testid="nav-login-button">Log in</Button>
          <Button size="sm" className="text-[13px] h-9 bg-orange-500 hover:bg-orange-600 shadow-sm shadow-orange-500/20" onClick={() => navigate("/register")} data-testid="nav-signup-button">
            Get started <ArrowRight className="w-3.5 h-3.5 ml-1" />
          </Button>
        </div>
        <button className="md:hidden p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
          {mobileMenuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>
      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-t px-5 py-4 space-y-3">
          <Link to="/#features" className="block text-sm text-slate-600 py-1" onClick={() => setMobileMenuOpen(false)}>Features</Link>
          <Link to="/#pricing" className="block text-sm text-slate-600 py-1" onClick={() => setMobileMenuOpen(false)}>Pricing</Link>
          <Link to="/faqs" className="block text-sm text-slate-600 py-1" onClick={() => setMobileMenuOpen(false)}>FAQs</Link>
          <div className="flex gap-2 pt-2">
            <Button variant="outline" size="sm" className="flex-1 text-xs" onClick={() => navigate("/login")}>Log in</Button>
            <Button size="sm" className="flex-1 text-xs bg-orange-500 hover:bg-orange-600" onClick={() => navigate("/register")}>Get started</Button>
          </div>
        </div>
      )}
    </nav>
  );
}

export function PublicFooter() {
  const navigate = useNavigate();

  return (
    <footer className="py-10 px-5 border-t border-slate-100">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        <Link to="/" className="flex items-center">
          <ZestLogo height="h-7" />
        </Link>
        <div className="flex flex-wrap gap-6 text-[12px] text-slate-400">
          <Link to="/#features" className="hover:text-slate-600">Features</Link>
          <Link to="/#pricing" className="hover:text-slate-600">Pricing</Link>
          <Link to="/faqs" className="hover:text-slate-600">FAQs</Link>
          <Link to="/privacy" className="hover:text-slate-600">Privacy Policy</Link>
          <Link to="/terms" className="hover:text-slate-600">Terms of Service</Link>
        </div>
        <p className="text-[12px] text-slate-400">&copy; {new Date().getFullYear()} Zest AI. All rights reserved.</p>
      </div>
    </footer>
  );
}
